import { buildUseStyles, useTheme } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import {
  Area, AreaChart as RechartAreaChart, ResponsiveContainer, XAxis, YAxis,
} from 'recharts';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';

const useStyles = buildUseStyles('HoldingsSectionContent', () => ({
  root: {},
}));

const AreaChart = ({
  className,
  width,
  height,
  baseValue,
  data,
  xDataKey,
  yDataKey,
  margin,
  xTickFormatFn,
  yTickFormatFn,
  yTicks,
  xTicks,
}) => {
  const theme = useTheme();
  const classes = useStyles(theme);

  return (
    <ResponsiveContainer
      className={classNames(className, classes.root)}
      width={width}
      height={height}
    >
      <RechartAreaChart
        baseValue={baseValue}
        data={data}
        margin={margin}
      >
        <defs>
          <defs>
            <linearGradient id="blueGradient" x1="246" y1="0" x2="246" y2="110" gradientUnits="userSpaceOnUse">
              <stop stopColor="#007099" stopOpacity="0.3" />
              <stop offset="1" stopColor="#C1F0E2" stopOpacity="0.05" />
            </linearGradient>
          </defs>
        </defs>
        <XAxis
          interval={0}
          dataKey={xDataKey}
          tickFormatter={xTickFormatFn}
          ticks={xTicks}
          axisLine={false}
          tickLine={false}
          tick={{ textAnchor: 'end' }}
        />
        <YAxis
          ticks={yTicks}
          dataKey={yDataKey}
          tickFormatter={yTickFormatFn}
          axisLine={false}
          tickLine={false}
        />
        <Area type="monotone" dataKey={yDataKey} strokeWidth={2} stroke="#2288bb" fill="url(#blueGradient)" />
      </RechartAreaChart>
    </ResponsiveContainer>
  );
};

AreaChart.propTypes = {
  className: PropTypes.string,
  width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  height: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  baseValue: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  data: PropTypes.arrayOf(PropTypes.object).isRequired,
  xDataKey: PropTypes.string,
  yDataKey: PropTypes.string,
  margin: PropTypes.oneOfType([PropTypes.number, PropTypes.object]),
  xTickFormatFn: PropTypes.func,
  yTickFormatFn: PropTypes.func,
  yTicks: PropTypes.array,
  xTicks: PropTypes.array,
};

AreaChart.defaultProps = {
  className: '',
  width: '100%',
  height: '100%',
  baseValue: 'auto',
  xDataKey: 'name',
  yDataKey: 'value',
  margin: undefined,
  xTickFormatFn: undefined,
  yTickFormatFn: undefined,
  yTicks: undefined,
  xTicks: undefined,
};

export default AreaChart;
